import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUpIcon, BuildingIcon, CreditCardIcon } from 'lucide-react';
export const WhatYouGetSection = () => {
  const benefits = [{
    number: '1',
    icon: <TrendingUpIcon size={28} data-id="element-239" />,
    title: 'Optimizar tu Perfil de Crédito',
    description: 'Aprenderas a construir un Perfil de Crédito sólido que sea atractivo para los bancos, enfocado en lograr mas aprobaciones con límites de credito altos.'
  }, {
    number: '2',
    icon: <BuildingIcon size={28} data-id="element-240" />,
    title: 'Estructurar una LLC',
    description: 'Entenderas la Estructura correcta de una Empresa y cómo conectarla al Sistema de Credito para acceder a cualquier Financiamiento Comercial.'
  }, {
    number: '3',
    icon: <CreditCardIcon size={28} data-id="element-241" />,
    title: 'Acceder a Financiamiento al 0%',
    description: 'Descubre cómo un Perfil de Crédito optimizado y una Empresa correctamente estructurada pueden conseguirte más de $250K al 0% de interés.'
  }];
  return <section className="w-full py-8 sm:py-12 px-4 bg-white" data-id="element-242">
      <div className="container mx-auto max-w-6xl" data-id="element-243">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-6 sm:mb-10" data-id="element-244">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-black mb-3" data-id="element-245">
            ¿Qué vas a obtener en esta Masterclass?
          </h2>
          <div className="h-1 w-20 bg-[#7A3EFF] mx-auto rounded-full" data-id="element-246" />
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 sm:gap-6" data-id="element-247">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="relative bg-white border-2 border-[#7A3EFF] rounded-2xl p-5 sm:p-6 shadow-md" data-id="element-248">
              {/* Number Badge */}
              <div className="absolute -top-3 -left-3 w-10 h-10 bg-[#7A3EFF] text-white rounded-full flex items-center justify-center text-xl font-bold shadow-lg" data-id="element-249">
                {benefit.number}
              </div>
              <div className="text-[#7A3EFF] mb-3 mt-2" data-id="element-250">{benefit.icon}</div>
              <h3 className="text-lg sm:text-xl font-bold text-black mb-2" data-id="element-251">
                {benefit.title}
              </h3>
              <p className="text-gray-700 leading-relaxed text-sm sm:text-base" data-id="element-252">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};